import React, { useState } from "react";
import Cards from "../../cards/Cards";
import PrimaryHead from "../../headings/PrimaryHead";
import PrimaryButton from "../forms/buttons/PrimaryButton";
import SecondaryButton from "../forms/buttons/SecondaryButton";
import "./Carousel.css";
function Carousel() {
  return (
    <div class="slider">

      <div class="slides">
        <div id="slide-0">
          <div className="content_wrap_car">
        <PrimaryHead name="Doctor On Demand"/>
          <p className="para_carousel">
          Doctor-on-Demand enables you to speak with experienced and licensed specialist doctors instantly at any time of the day. Now no one needs to wait in a line to consult a doctor, you can consult any doctor anytime with just one click.
          </p>
        <a href="https://dr-on-demand.vercel.app/">  <PrimaryButton name="Source Code"/></a>
        <a href="https://github.com/narayan954/hackathon-project-frontend-1">  <SecondaryButton name="See Live"/></a>
          </div>
        </div>
        <div id="slide-1">
          <div className="content_wrap_car">
          <PrimaryHead name="Smart Brain"/>
          <p className="para_carousel">
          A web application which can detect faces in an image using an image recognition API.Has its own server and a user database. Uses ReactJs in the front end, Node.JS, Express.JS, Clarifai API and PostgreSQL for its server and database.
          </p>
          <a href="https://smartbrain-facedetection.web.app/"> <PrimaryButton name="Source Code"/></a>
          <a href="https://github.com/narayan954/smartbrain-frontend"> <SecondaryButton name="See Live"/></a>
          </div>
        </div>
        <div id="slide-2">
          <div className="content_wrap_car">
        <PrimaryHead name="RoboFriends"/>
          <p className="para_carousel">
          A react application displaying a list of our robot friends befriended from robohash.org's api. It also utilizes tachyons for styling and custom font .
          </p>
          <a href="https://narayan954.github.io/robofriends/">  <PrimaryButton name="Source Code"/></a>
          <a href="https://github.com/narayan954/robofriends">   <SecondaryButton name="See Live"/></a>
          </div>
        </div>
      </div>
    
    </div>
  );
}

export default Carousel;
